/* useTopSpaces.js
 * Place at: src/hooks/useTopSpaces.js
 *
 * Fetches top spaces for main feed card injection.
 * Cache TTL: 10 minutes (updated by weekly cron job anyway)
 * Returns up to 2 spaces: most new members + most liked post this week.
 */

import { useState, useEffect, useRef } from "react";
import { fetchTopSpacesForFeed } from "../lib/spaceQueries";

const TOP_SPACES_CACHE_TTL = 10 * 60 * 1000; // 10 minutes
let topSpacesCache = null; // module-level singleton

export function useTopSpaces() {
  const [topSpaces, setTopSpaces] = useState([]);
  const [loading,   setLoading]   = useState(false);
  const fetchedRef  = useRef(false);

  useEffect(() => {
    // Return from module-level cache if fresh
    if (topSpacesCache && Date.now() - topSpacesCache.fetchedAt < TOP_SPACES_CACHE_TTL) {
      setTopSpaces(topSpacesCache.data);
      return;
    }

    if (fetchedRef.current) return;
    fetchedRef.current = true;

    let cancelled = false;
    setLoading(true);

    fetchTopSpacesForFeed()
      .then(data => {
        if (cancelled) return;
        topSpacesCache = { data, fetchedAt: Date.now() };
        setTopSpaces(data);
      })
      .catch(err => {
        if (cancelled) return;
        // Non-fatal — space cards just won't show
        console.warn("[useTopSpaces] failed to fetch top spaces:", err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  return { topSpaces, loading };
}